var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              staticClass: "lessonDialog",
              attrs: {
                title: "待上课程",
                visible: _vm.dialogShow,
                width: "20%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogShow = $event
                },
                close: _vm.closeDialog,
              },
            },
            [
              _vm._l(_vm.lessonList, function (item, index) {
                return _c(
                  "el-card",
                  { key: index, staticStyle: { padding: "0px" } },
                  [
                    _c("img", {
                      staticClass: "pptCover",
                      attrs: { src: item.lesson.pptCover },
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "flex-end" }, [
                        _c("span", { staticClass: "lessonName" }, [
                          _vm._v(_vm._s(item.lesson.name)),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.teacherName))]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-end" }, [
                        _c("div", [
                          _c("span", [_vm._v(_vm._s(`${item.date}`))]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(`${item.startTime}-${item.endTime}`)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "lesson-one" }, [
                          _vm._v(
                            _vm._s(item.onlineTeaching ? "线上课" : "线下课")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-end" },
                        [
                          _c(
                            "el-alert",
                            {
                              attrs: {
                                title: _vm.countDown > 0 ? "距开始上课" : "",
                                type: "success",
                                center: "",
                                closable: false,
                              },
                            },
                            [
                              _vm.countDown > 0
                                ? _c(
                                    "span",
                                    { staticStyle: { "font-size": "30px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          `${parseInt(
                                            _vm.countDown / 60 / 60
                                          )} 时 ${parseInt(
                                            (_vm.countDown / 60) % 60
                                          )} 分 ${_vm.countDown % 60} 秒`
                                        )
                                      ),
                                    ]
                                  )
                                : _c("span", { staticClass: "defaultText" }, [
                                    _vm._v("已开始上课"),
                                  ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "button",
                              attrs: {
                                type: "primary",
                                round: "",
                                disabled: _vm.disabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.inClassroomDialogVisible(item)
                                },
                              },
                            },
                            [_vm._v("进入课堂")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _c("CodeDialog", {
                ref: "codeDialog",
                attrs: { lessonId: _vm.currentLessonId },
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/lesson/component/lessonDialog.vue?vue&type=template&id=1b0acaff&
// module id = null
// module chunks = 